export type RhythmScale = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export enum Rhythm {
  xs = 'var(--torq-experimental-rhythm-xs)',
  sm = 'var(--torq-experimental-rhythm-sm)',
  md = 'var(--torq-experimental-rhythm-md)',
  lg = 'var(--torq-experimental-rhythm-lg)',
  xl = 'var(--torq-experimental-rhythm-xl)',
}
